import { ErrorHandler, Injectable } from "@angular/core";
import { Router } from "@angular/router";

import * as HttpStatus from "http-status-codes";
import { HttpErrorResponse } from "@angular/common/http";

import { map, tap, catchError, retry } from "rxjs/operators";
import { Observable, throwError } from "rxjs";

@Injectable()
export class HUBErrorHandler implements ErrorHandler {
  constructor(private router: Router) {}

  public handleError(error: HttpErrorResponse) {
    console.error(error);
    const httpErrorCode = error.error;
    switch (httpErrorCode) {
      case HttpStatus.UNAUTHORIZED:
        console.log("UNAUTHORIZED" + error.message);
        // this.router.navigateByUrl('');
        break;
      case HttpStatus.FORBIDDEN:
        console.log("FORBIDDEN: " + error.message);
        this.router.navigateByUrl("/404");
        break;
      case HttpStatus.BAD_REQUEST:
        console.log("BAD_REQUEST: " + error.message);
        this.showError(error.message);
        break;
      case HttpStatus.REQUEST_TIMEOUT:
        console.log("REQUEST_TIMEOUT: " + error.message);
        this.showError(error.message);
        break;
      case HttpStatus.NOT_FOUND:
        console.log("NOT_FOUND: " + error.message);
        this.showError(error.message);
        break;
      default:
        console.log("OH snap.");
    }
  }
  //
  public handleHttpError(error: HttpErrorResponse) {
    console.error(error);
    const httpErrorCode = error.error;
    switch (httpErrorCode) {
      case HttpStatus.UNAUTHORIZED:
        console.log(`UNAUTHORIZED: ${error.status}\nMessage: ${error.message}`);
        this.router.navigateByUrl("");
        break;
      case HttpStatus.FORBIDDEN:
        console.log("FORBIDDEN: " + error.message);
        this.router.navigateByUrl("/404");
        break;
      case HttpStatus.BAD_REQUEST:
        console.log("BAD_REQUEST: " + error.message);
        this.showError(error.message);
        break;
      case HttpStatus.REQUEST_TIMEOUT:
        console.log("REQUEST_TIMEOUT: " + error.message);
        this.showError(error.message);
        break;
      case HttpStatus.NOT_FOUND:
        console.log("NOT_FOUND: " + error.message);
        this.showError(error.message);
        break;
      default:
        console.log("OH snap.");
    }
  }

  //
  public handleServerClientError(error: { error: { message: any }; status: any; message: any }) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage || error);
    return throwError(errorMessage);
  }

  private showError(message: string) {
    console.log("Hello" + message);
  }
}
